import React from "react";
import value1 from "../assets/value1.png";
import value2 from "../assets/value2.png";
import value3 from "../assets/value3.png";
import value4 from "../assets/value4.png";
import "../style//value.css";

const Value = () => {
  const valueCards = [
    {
      id: 1,
      title: "INDEPENDENCE",
      disc: "We support our residents to live as independently as possible, encouraging personal choice, skill development, and confidence. We believe in fostering resilience and enabling individuals to take ownership of their journey.",
      image: value1,
      quote: "“We rise by lifting others”",
      author: "ROBERT INGERSOLL",
    },
    {
      id: 2,
      title: "RESPECT & DIGNITY",
      disc: "We honour the individuality of every resident, recognising their history, voice, preferences, and potential. We uphold dignity in every interaction and non-judgement.",
      image: value2,
      quote:
        "“Respect was earned, not demanded, but Dignity was taught by example”",
      author: "Julie Garwood",
    },
    {
      id: 3,
      title: "COMPASSION",
      disc: "We lead with empathy, kindness, and patience. Our team takes the time to understand each resident’s unique needs, behaviours, and emotions, responding with warmth and consistency to build meaningful relationships.",
      image: value3,
      quote: "“Compassion is the basis of morality”",
      author: "Arthur Schopenhauer",
    },
    {
      id: 4,
      title: "INCLUSION & DIVERSITY",
      disc: "We are committed to a culture of inclusion, respect, and equality. We value the diverse backgrounds of our staff and residents, promoting fairness, dignity, and zero tolerence for discrimination in all that we do.",
      image: value4,
      quote: "“What divides us pales in comparision to what unites us”",
      author: "Edward Kennedy",
    },
  ];

  return (
    <div className="value-container">
      <h1>Values That Define Us</h1>
      <h5>
        Our values are not just words on a page – they are the foundation of
        everything we do. They guide our daily decisions, shape our
        interactions, and ensure that every person we support receives care that
        reflects these core principles.
      </h5>
      <section className="value-section1">
        {valueCards.map((card) => (
          <div key={card.id} className="value-section-div-items">
            <div className="card-content-value">
              <img
                src={card.image}
                alt={`${card.name}, ${card.title}`}
                loading="lazy"
                onError={(e) => (e.target.src = "/assets/fallback.png")}
              />
              <h2>{card.title}</h2>
              <h3 className="disc">{card.disc}</h3>
              <h4 className="quote">{card.quote}</h4>
              <h5 className="title">{card.author}</h5>
              <div className="hr"></div>
            </div>
          </div>
        ))}
      </section>
    </div>
  );
};

export default Value;
